import i18n from '@shared/config/i18n';
import { ChildBase } from '../defaults';

const { t } = i18n;

export const modal: ChildBase = {
  spec: 'modal',
  token: 'modal-error',
  data: {
    title: '',
    value: '',
    visible: false,
  },
  styles: {
    '& .MuiPaper-root': { width: '500px', padding: '24px', gap: '24px' },
    '& .modal-controls': {
      gap: '16px',
      justifyContent: 'flex-end',
    },
  },
  child: [
    {
      spec: 'button-text',
      token: 'error-close-button',
      data: {
        label: t('close')!,
      },
      meta: {
        validations: [],
        triggers: [
          {
            events: ['on-click'],
            targets: ['modal-error'],
            handlers: ['hide-modal-error'],
          },
        ],
        actions: [
          {
            kind: 'changes',
            token: 'hide-modal-error',
            spec: {
              target: 'modal-error',
              changes: {
                'data.visible': { type: 'val', value: false },
                'data.title': { type: 'val', value: '' },
                'data.value': { type: 'val', value: '' },
              },
            },
          },
        ],
        styling: {},
      },
    },
  ],
  meta: {
    triggers: [
      {
        events: ['on-close'],
        targets: ['modal-error'],
        handlers: ['hide-modal-error'],
      },
    ],
    actions: [
      {
        kind: 'changes',
        token: 'show-modal-error',
        spec: {
          target: 'modal-error',
          changes: {
            'data.visible': {
              type: 'val',
              value: true,
            },
            'data.title': {
              type: 'val',
              value: t('RequestError'),
            },
            'data.value': {
              type: 'func',
              value: `({responseRequestData}) => responseRequestData.response?.message ?? responseRequestData.response?.data?.message ?? 'error'`,
            },
          },
        },
      },
    ],
  },
};
